export const columnList = (groupLevelName: 'Team' | 'Company') => [
    {
        field: `Budget_${groupLevelName}`,
        defaultValue: `${groupLevelName}`,
        isLocalized: true,
        section: "Budget",
      },
      {
        field: `Monthly_${groupLevelName}_Budget`,
        defaultValue: `Monthly ${groupLevelName} Budget`,
        isLocalized: true,
        section: "Budget",
      },
      {
        field: `${groupLevelName}_Coins_Available`,
        defaultValue: `${groupLevelName} Coins Available`,
        isLocalized: true,
        section: "Budget",
      },
      {
        field: `${groupLevelName}_Total_Coins_Awarded`,
        defaultValue: `${groupLevelName} Total Coins Awarded`,
        isLocalized: true,
        section: "Budget",
      },
      {
        field: `${groupLevelName}_Coins_Percentage_Available`,
        defaultValue: `${groupLevelName} Coins % Available`,
        isLocalized: true,
        section: "Budget",
      },
];

export const headerItems = (totalAmount: number, totalCoinsAwarded: number) => {
    const percentage = ((totalAmount - totalCoinsAwarded) / totalAmount) * 100;

    return [
        {
            cells: [
                {
                    text: "GamificationAdmin",
                    isLocalizedText: true,
                    localizedSection: "Page_Names",
                    fontColor: [0, 0, 0],
                    bold: true,
                },
            ],
        },
        {
            cells: [
                {
                    text: "Budget_Meter",
                    isLocalizedText: true,
                    localizedSection: "Budget",
                    fontColor: [0, 0, 0],
                    bold: true,
                },
            ],
        },
        {
            cells: [
                {
                    text: "Company",
                    isLocalizedText: true,
                    localizedSection: "Company",
                },
                { customName: "CompanyName" },
            ],
        },
        {
            cells: [
                {
                    text: "Month_Header",
                    isLocalizedText: true,
                    localizedSection: "Budget",
                },
                {
                    text: new Date().toLocaleString(CVCultureName, { month: "long" }),
                    isLocalizedText: true,
                    localizedSection: "Common",
                },
            ],
        },
        {
            cells: [
                {
                    text: "Monthly_Total_Budget",
                    isLocalizedText: true,
                    localizedSection: "Budget",
                },
                { text: `${totalAmount}` },
            ],
        },
        {
            cells: [
                {
                    text: "Coins_Available",
                    isLocalizedText: true,
                    localizedSection: "Budget",
                },
                {
                    text: `${totalAmount - totalCoinsAwarded > 0
                        ? totalAmount - totalCoinsAwarded
                        : 0
                        }`,
                },
            ],
        },
        {
            cells: [
                {
                    text: "Total_Coins_Awarded",
                    isLocalizedText: true,
                    localizedSection: "Budget",
                },
                { text: `${totalCoinsAwarded}` },
            ],
        },
        {
            cells: [
                {
                    text: "Total_Coins_Percentage_Available",
                    isLocalizedText: true,
                    localizedSection: "Budget",
                },
                {
                    text: `${(percentage > 0 ? percentage : 0).toFixed(2)}%`,
                },
            ],
        },
        { cells: [{ text: "" }] },
    ];
};
